import { StackView, Group, Logo, Text, Tooltip } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../vendor/topbar/colors.js';

const PcoAppNames = {
    groups: "Groups",
    services: "Services",
};
const ChannelMeta = ({ appName, channel }) => {
    var _a, _b;
    if (!appName)
        return null;
    let resourceType;
    let resourceId;
    switch (appName) {
        case "Groups": {
            const metadata = channel.data[appName];
            resourceType = "Group";
            if ((_a = metadata === null || metadata === undefined ? undefined : metadata.names) === null || _a === undefined ? undefined : _a.length) {
                resourceId = (_b = metadata.names) === null || _b === undefined ? undefined : _b.join(", ");
            }
            break;
        }
        case "Services": {
            const metadata = channel.data[appName];
            resourceType = (metadata === null || metadata === undefined ? undefined : metadata.dates) ? "Plan" : "Team";
            if (metadata === null || metadata === undefined ? undefined : metadata.dates) {
                resourceId = metadata.dates;
            }
            break;
        }
    }
    return (React.createElement(Group, { radius: 4, spacing: "0.25px", className: "channel-meta", maxWidth: "100%" },
        React.createElement(StackView, { alignment: "center", axis: "horizontal", backgroundColor: colors.lightNeutral95, borderColor: colors.lightNeutral95, borderWidth: 1, distribution: "center", padding: 0.5, paddingHorizontal: 1, spacing: 0.5 },
            React.createElement(Logo, { markOnly: true, name: appName.toLowerCase(), size: "15px", theme: "color" }),
            React.createElement(Text, { lineHeight: "13px", size: 5, weight: 500 }, resourceType)),
        resourceId && (React.createElement(StackView, { alignment: "center", borderColor: colors.lightNeutral95, borderLeftWidth: 0, borderWidth: 1, distribution: "center", padding: 0.5, paddingHorizontal: 1, shrink: 1 },
            React.createElement(Tooltip, { title: resourceId, openDelay: 800 },
                React.createElement(Text, { color: "foregroundSecondary", lineHeight: "13px", size: 5, truncate: true, maxWidth: "100%" }, resourceId))))));
};
const ChannelMetas = ({ channel }) => {
    var _a;
    if (!((_a = channel === null || channel === undefined ? undefined : channel.data) === null || _a === undefined ? undefined : _a.pco_apps))
        return null;
    const metas = channel.data.pco_apps.map((pco_app) => (React.createElement(ChannelMeta, { key: pco_app, appName: PcoAppNames[pco_app], channel: channel })));
    return (React.createElement(StackView, { axis: "horizontal", maxWidth: "calc(100% + 24px)" }, metas));
};

export { ChannelMetas };
//# sourceMappingURL=channel_metas.js.map
